var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLike(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.06449 16.9999H2.6258C2.19461 16.9999 1.78108 16.8313 1.47618 16.5313C1.17129 16.2312 1 15.8243 1 15.3999V9.79994C1 9.3756 1.17129 8.96864 1.47618 8.66858C1.78108 8.36852 2.19461 8.19995 2.6258 8.19995H5.06449M10.7548 6.59996V3.39998C10.7548 2.76347 10.4979 2.15302 10.0405 1.70294C9.58316 1.25285 8.96287 1 8.31609 1L5.06449 8.19995V16.9999H14.234C14.6261 17.0043 15.0066 16.869 15.3053 16.6191C15.6041 16.3692 15.801 16.0214 15.8598 15.6399L16.9816 8.43995C17.017 8.21064 17.0012 7.9765 16.9355 7.75376C16.8698 7.53102 16.7557 7.325 16.601 7.14997C16.4464 6.97495 16.2549 6.83511 16.0399 6.74014C15.8249 6.64517 15.5915 6.59734 15.3558 6.59996H10.7548Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/LIKE.6e7c3763cbec81a4fcc8e37810d5f62a.svg";
export { ForwardRef as ReactComponent };